import React from 'react';
import Divider from 'material-ui/Divider';
import Paper from 'material-ui/Paper';
import TextField from 'material-ui/TextField';

function Profile(props) {
    return (
        <div className="inputPageContainer">
            <p className="errorMessage">{props.message}</p>
            <Paper zDepth={2} className="inputPage" style={{paddingTop: "30px", paddingBottom: "30px"}}>
                <h1 className="formSubHeader">Edit Profile</h1>
                <form onSubmit={props.handleEdit}>
                    <TextField
                        floatingLabelText="Email Address"
                        style={{marginLeft: 20, width: "90%"}}
                        underlineShow={false}
                        floatingLabelFixed={true}
                        type="email"
                        name="email"
                        onChange={props.handleChange}
                        value={props.email}/>
                    <Divider />
                    <TextField
                        floatingLabelText="First Name"
                        style={{marginLeft: 20, width: "90%"}}
                        underlineShow={false}
                        floatingLabelFixed={true}
                        type="text"
                        name="firstName"
                        onChange={props.handleChange}
                        value={props.firstName}/>
                    <Divider />
                    <TextField
                        floatingLabelText="Last Name"
                        floatingLabelFixed={true}
                        style={{marginLeft: 20, width: "90%"}}
                        underlineShow={false}
                        type="text"
                        name="lastName"
                        onChange={props.handleChange}
                        value={props.lastName}/>
                    <Divider />
                    {props.isStudent === "student" ?
                        <TextField
                            floatingLabelText="Student ID"
                            floatingLabelFixed={true}
                            style={{marginLeft: 20, width: "90%"}}
                            underlineShow={false}
                            type="text"
                            name="studentId"
                            onChange={props.handleChange}
                            value={props.studentId}/>
                        : null
                    }
                    <Divider />
                    <button className="pink">Save</button>
                </form>
            </Paper>
            <p className="errorMessage">{props.passwordMsg}</p>
            <Paper zDepth={2} className="inputPage" style={{paddingTop: "30px", paddingBottom: "30px", marginTop: "50px"}}>
                <h1 className="formSubHeader">Change Password</h1>
                <form onSubmit={props.handlePasswordSubmit}>
                    <TextField
                        hintText="New Password"
                        style={{marginLeft: 20, width: "90%"}}
                        underlineShow={false}
                        type="password"
                        name="newPassword"
                        onChange={props.handleChange}
                        value={props.newPassword}/>
                    <Divider />
                    <TextField
                        hintText="Repeat New Password"
                        style={{marginLeft: 20, width: "90%"}}
                        underlineShow={false}
                        type="password"
                        name="newPasswordRepeat"
                        onChange={props.handleChange}
                        value={props.newPasswordRepeat}/>
                    <Divider />
                    <button className="pink">Save</button>
                </form>
            </Paper>
        </div>
    );
}

export default Profile;
